import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Topbar from './Topbar'
import Sidebar from './Sidebar'
import Footer from './Footer'
import ProtectedView from '../protected_view'
import { Contact } from './Include'

const Template = (props: { children?: React.ReactNode }) => {
  // Single source of truth for sidebar state
  // Start open on desktop (>=992px), closed on mobile
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 992)
  const location = useLocation()

  // Listen for toggle events dispatched by Topbar
  useEffect(() => {
    const handleToggle = () => {
      setSidebarOpen(prev => !prev)
    }
    window.addEventListener('toggle-sidebar', handleToggle)
    return () => window.removeEventListener('toggle-sidebar', handleToggle)
  }, [])

  // Close sidebar on mobile whenever route changes
  useEffect(() => {
    if (window.innerWidth < 992) {
      setSidebarOpen(false)
    }
  }, [location.pathname])

  // Broadcast actual sidebar state so Topbar can sync its icon
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('sidebar-state-changed', { detail: { isOpen: sidebarOpen } })
    )
  }, [sidebarOpen])

  return (
    <>
      <div className={`horizontalMenucontainer ${sidebarOpen ? 'sidebar-is-open' : 'sidebar-is-closed'}`}>
        <div className="page">
          {/* Top navigation bar - fixed at top */}
          <Topbar />

          {/* Main content area with sidebar */}
          <div className="page-main">
            {/* Sidebar receives open state and close callback from Template */}
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Main content area */}
            <div className="main-content app-content">
              <div className="jumps-prevent" style={{ paddingTop: '65px' }}></div>
              <div className="main-container container-fluid">
                <ProtectedView />
              </div>
            </div>
          </div>

          {/* Footer */}
          <Footer />

          {/* Back to top button */}
          <a href="#top" id="back-to-top" className="no-print">
            <i className="fa fa-angle-up"></i>
          </a>
        </div>
      </div>
    </>
  )
}

export default Template
